// Module
var code = `<div class="group-button-container" as-tooltip="tooltip">
    {{#each buttonsInfo : i}}
        <terceraButton name="{{.name}}" text="{{.text}}" terceraButtonStyle="group-button" on-btnClick="@this.onBtnClick(buttonsInfo[i])" canCheck="true" checked="{{.isChecked}}"/>                                                      
    {{/each}}
</div>`;
// Exports
export default code;